module.exports = __webpack_public_path__ + "media/img/pay-4-3dd1c06a071243de27e21b2773ef0d44.svg";